import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class WarehouseRestockPersonResponse {
  @jsonMember(String)
  public readonly dignity?: Nillable<string>;

  @jsonMember(String)
  public readonly email?: Nillable<string>;

  @jsonMember(String)
  public readonly phone?: Nillable<string>;
}
